import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import(/* webpackChunkName: "solutions" */ '../views/Solutions.vue')
  },
  {
    path: '/platforms',
    name: 'Platforms',
    component: () => import(/* webpackChunkName: "platforms" */ '../views/Platforms.vue')
  },
  {
    path: '/how-it-works',
    name: 'HowItWork',
    component: () => import(/* webpackChunkName: "how-it-work" */ '../views/HowItWork.vue')
  },
  {
    path: '/imdf',
    name: 'IMDF',
    component: () => import(/* webpackChunkName: "imdf" */ '../views/IMDF.vue')
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import(/* webpackChunkName: "contacts" */ '../views/Contacts.vue')
  },
  {
    path: '/construction',
    name: 'Construction',
    component: () => import(/* webpackChunkName: "construction" */ '../views/Construction.vue')
  },
  {
    path: '/retail',
    name: 'Retail',
    component: () => import(/* webpackChunkName: "retail" */ '../views/Retail.vue')
  },
  {
    path: '/health-care',
    name: 'HealthCare',
    component: () => import(/* webpackChunkName: "health-care" */ '../views/HealthCare.vue')
  },
  {
    path: '/event-venues',
    name: 'EventVenues',
    component: () => import(/* webpackChunkName: "event-venues" */ '../views/EventVenues.vue')
  },
  {
    path: '/transportation',
    name: 'Transportation',
    component: () => import(/* webpackChunkName: "transportation" */ '../views/Transportation.vue')
  },
  {
    path: '/hospitality',
    name: 'Hospitality',
    component: () => import(/* webpackChunkName: "hospitality" */ '../views/Hospitality.vue')
  },
  {
    path: '/smart-venues',
    name: 'SmartVenues',
    component: () => import(/* webpackChunkName: "smart-venues" */ '../views/SmartVenues.vue')
  },
  {
    path: '/smart-construction',
    name: 'SmartConstruction',
    component: () => import(/* webpackChunkName: "smart-construction" */ '../views/SmartConstruction.vue')
  },
  {
    path: '/our-client',
    name: 'OurClient',
    component: () => import(/* webpackChunkName: "our-client" */ '../views/OurClient.vue')
  },
  {
    path: '/who-are-we',
    name: 'WhoAreWe',
    component: () => import(/* webpackChunkName: "who-are-we" */ '../views/WhoWeAre.vue')
  },
  {
    path: '/our-team',
    name: 'OurTeam',
    component: () => import(/* webpackChunkName: "our-team" */ '../views/OurTeam.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
